import React from "react";
import Venue from "../../Models/Venue";
import { DialogActions, DialogContent, Grid, IconButton, Typography } from "@mui/material";
import EditString, { useStringInput } from "../components/EditFields/EditString";
import { useDialog } from "../../utils/DialogProvider";
import DialogTitle from "@mui/material/DialogTitle";
import { Close } from "@mui/icons-material";
// @ts-ignore
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { withStyles } from "tss-react/mui";
// @ts-ignore
import { __ } from "../../../translations/utils.jsx";
// @ts-ignore
import SaveButton from "../../../components/CustomInput/SaveButton.jsx";
// @ts-ignore
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

type EditVenueProps = {
  venue: Venue;
  onChange: (venue: Venue) => Promise<any>;
  classes: any;
};

function CreateVenue(props: EditVenueProps) {
  const { classes } = props;
  const [venue, setVenue] = React.useState<Venue>(props.venue);
  const [saving, setSaving] = React.useState(false);
  const [, closeDialog] = useDialog();
  const nameInputProps = useStringInput(venue, setVenue, "name");
  const cityInputProps = useStringInput(venue, setVenue, "city");
  const addressInputProps = useStringInput(venue, setVenue, "address");
  const postalCodeInputProps = useStringInput(venue, setVenue, "postal_code");
  const countryInputProps = useStringInput(venue, setVenue, "country");
  const emailAddressInputProps = useStringInput(venue, setVenue, "email_address");
  const phoneNumberInputProps = useStringInput(venue, setVenue, "phone_number");
  const websiteInputProps = useStringInput(venue, setVenue, "website");
  const cocNumberInputProps = useStringInput(venue, setVenue, "coc_number");

  return (
    <>
      <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
        <IconButton
          className={classes.modalCloseButton}
          color={"default"}
          disabled={false}
          href={""}
          onClick={() => {
            closeDialog();
          }}
        >
          <Close className={classes.modalClose} />
        </IconButton>
        <h4 className={classes.modalTitle}>
          <TranslationWrapper tDefault={"Maak nieuwe venue aan"} tKey={"venues.modal.new.title"} />
        </h4>
      </DialogTitle>
      <DialogContent className={classes.modalBody}>
        <Grid container spacing={1} style={{ maxWidth: 480 }}>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{nameInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...nameInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{cityInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...cityInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{addressInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...addressInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{postalCodeInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...postalCodeInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{countryInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...countryInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{emailAddressInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...emailAddressInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{phoneNumberInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...phoneNumberInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{cocNumberInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...cocNumberInputProps} />
          </Grid>
          <Grid alignItems={"center"} container item xs={4}>
            <Typography>{websiteInputProps.label}</Typography>
          </Grid>
          <Grid alignItems={"center"} container item xs={8}>
            <EditString {...websiteInputProps} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
        <SaveButton
          buttonText={<TranslationWrapper tDefault={"Aanmaken"} tKey={"venues.modal.new.form.savebutton.text"} />}
          disabled={false}
          onClick={() => {
            setSaving(true);
            props
              .onChange(venue)
              .then(() => {
                setSaving(false);
                closeDialog();
              })
              .catch(() => {
                setSaving(false);
              });
          }}
          saving={saving}
        />
      </DialogActions>
    </>
  );
}

export default withStyles(CreateVenue, notificationsStyle);
